// const PARTNER_BASE = "http://localhost:8080/v1/r2r/partner";

// export async function kycVerification(partnerId,idType,idNumber) {
//   const res = await fetch(`${PARTNER_BASE}/kyc`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ partnerId, idType,idNumber})
//   });
//   if (!res.ok) throw new Error("KYC Details enter failed");
//   return res.json();
// }
import axios from "../axiosInstance";
export const kycVerification = async (idType,idNumber) => {
  const res = await axios.post("/partner/kyc", {
    idType,
    idNumber,
  });
  return res.data;
};